var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChooseAllShopLocationsActive = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40.543,
    height: 39.348,
    viewBox: "0 0 40.543 39.348",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-first",
    x1: 0.061,
    y1: 0.15,
    x2: 0.939,
    y2: 0.718,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0173ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#0186ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#01b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01c5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-second",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#87b9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfdafa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35601",
    "data-name": "Group 35601",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8841",
    d: "M-19652.471-22011.9h-10.6a70.038,70.038,0,0,1-4.662,7.031,70.375,70.375,0,0,1-4.662-7.031h-10.6l-5.012,14.309h40.539Z",
    transform: "translate(19688.002 22036.941)",
    fill: "#bcd8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842",
    d: "M-19669.27-22032.9a10.684,10.684,0,0,0-10.73,10.639c-.062,10.154,10.73,22.744,10.73,22.744s10.793-12.594,10.73-22.744A10.666,10.666,0,0,0-19669.27-22032.9Z",
    transform: "translate(19689.539 22032.9)",
    fill: "url(#linear-gradient-first)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842-2",
    d: "M-19657.23-22017.9a5.068,5.068,0,0,0-4.77,5.32c-.027,5.076,4.77,11.373,4.77,11.373s4.8-6.3,4.77-11.373A5.078,5.078,0,0,0-19657.23-22017.9Z",
    transform: "translate(19693 22035.787)",
    fill: "url(#linear-gradient-second)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842-3",
    d: "M-19683.23-22017.9a5.066,5.066,0,0,0-4.77,5.32c-.027,5.076,4.77,11.373,4.77,11.373s4.8-6.3,4.77-11.373A5.078,5.078,0,0,0-19683.23-22017.9Z",
    transform: "translate(19688 22035.787)",
    fill: "url(#linear-gradient-second)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7120",
    "data-name": "Ellipse 7120",
    cx: 1.788,
    cy: 1.788,
    r: 1.788,
    transform: "translate(2.981 21.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7121",
    "data-name": "Ellipse 7121",
    cx: 1.788,
    cy: 1.788,
    r: 1.788,
    transform: "translate(33.981 21.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7122",
    "data-name": "Ellipse 7122",
    cx: 5.365,
    cy: 5.365,
    r: 5.365,
    transform: "translate(14.904 6.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7123",
    "data-name": "Ellipse 7123",
    cx: 1.788,
    cy: 1.788,
    r: 1.788,
    transform: "translate(18.481 9.594)",
    fill: "#d7282f"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChooseAllShopLocationsActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/choose-all-shop-locations-active.9704933d.svg";
export { ForwardRef as ReactComponent };